
import React from 'react';
import './FatcaCRSDeclaration.modules.css';
import RiskTolerance from './RiskTolerance/RiskTolerance'

import { useTranslation } from "react-i18next";


const FatcaCRSDeclaration3 = (props) => {
    const { t } = useTranslation();
    return (
        <div className="FatcaCRSDeclaration">
            <div className="form-container">
                <form className="dropdown-form">
                    <div className="form-group">
                        <h5 >{t("riskTolerance")}</h5>

                      
                        <div className="seekbar-wrapper">
                            <RiskTolerance  saveKycDataAPI={props.saveKycDataAPI} setIsCallAPI={props.setIsCallAPI} IsCallAPI={props.IsCallAPI}/>
                        </div>
                    </div>
                   



                    {/* <button type="submit" className="submit-button">Submit</button> */}
                </form>
            </div>
        </div>
    );
};


export default FatcaCRSDeclaration3;





